import React from 'react';
import PropTypes from 'prop-types';
import { TextField } from '@material-ui/core';
import LengthCounter from '@hydra/routes/pdf-editor/components/LengthCounter';

const onKeyDown = ({ save, cancel }) => e => {
  switch (e.key) {
    case 'Enter':
      save();
      break;
    case 'Escape':
      cancel();
      break;
    default:
      break;
  }
};

export const FormTextInput = ({ value, onChange, save, cancel, maxLength }) => {
  return (
    <>
      <TextField
        data-testid='text-input'
        error={maxLength && value.length >= maxLength}
        variant='outlined'
        type='text'
        onChange={e => onChange(e.target.value)}
        value={value}
        onKeyDown={onKeyDown({ save, cancel })}
        inputProps={maxLength ? { maxLength } : {}}
      />
      {maxLength ? <LengthCounter maxLength={maxLength} currentLength={value.length} /> : null}
    </>
  );
};

FormTextInput.propTypes = {
  cancel: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  save: PropTypes.func.isRequired
};

export default FormTextInput;
